import { API_URL } from '@/lib/apiConfig';
import { nativeRequestHeaders } from '@/lib/native';

let samples = [];
let sampleToken = '';
const pathOnly = value => value.split(/[?#]/)[0].slice(0, 240).split('/').map(part => /@|%40|\d|%[0-9a-f]{2}/i.test(part) || part.length > 48 ? ':id' : part).join('/');
export function recordTiming(metric, duration, route = '', status = 200, page = location.pathname) {
  if (!localStorage.getItem('token') || !Number.isFinite(duration) || duration < 0 || duration > 300000 || route.includes('/api/performance')) return;
  const token = localStorage.getItem('token');
  if (sampleToken !== token) { samples = []; sampleToken = token; }
  if (samples.length < 90) samples.push({ metric, duration: Math.round(duration), route: pathOnly(route), page: pathOnly(page), status, device: matchMedia('(max-width: 800px)').matches ? 'mobile' : 'desktop' });
}
function flush() {
  const token = localStorage.getItem('token');
  if (!token || token !== sampleToken) { samples = []; return; }
  if (!samples.length) return;
  const batch = samples.splice(0, 30);
  // Timings never block the UI; no retries or recursive instrumentation.
  fetch(`${API_URL}/api/performance/samples`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...nativeRequestHeaders() }, body: JSON.stringify({ samples: batch }), keepalive: true }).catch(() => {});
}
export function startPerformanceCollection() {
  setInterval(flush, 10000);
  let lcp = 0;
  const initialPage = location.pathname;
  function observe(type, callback, options = {}) {
    try { const observer = new PerformanceObserver(list => list.getEntries().forEach(callback)); observer.observe({ type, buffered: true, ...options }); } catch { /* Older browsers still report API timings. */ }
  }
  const navigation = () => { const entry = performance.getEntriesByType('navigation')[0]; if (!entry) return;
    recordTiming('ttfb', entry.responseStart - entry.requestStart, '', 200, initialPage);
    if (entry.loadEventEnd > 0) recordTiming('page_load', entry.loadEventEnd, '', 200, initialPage);
  };
  if (document.readyState === 'complete') setTimeout(navigation, 0);
  else window.addEventListener('load', () => setTimeout(navigation, 0), { once: true });
  observe('largest-contentful-paint', entry => { lcp = entry.startTime; });
  observe('event', entry => { if (entry.interactionId) recordTiming('interaction', entry.duration); }, { durationThreshold: 104 });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') { if (lcp) { recordTiming('lcp', lcp, '', 200, initialPage); lcp = 0; } flush(); } });
  window.addEventListener('pagehide', flush);
}
